// extracted by mini-css-extract-plugin
module.exports = {"separated":"index_separated_3dx4h","item":"index_item_qboeJ"};